import React from 'react';
import createIconSetFromIcoMoon from '@expo/vector-icons/createIconSetFromIcoMoon';
import { TextProps } from 'react-native';
import { styled } from 'dripsy';

import { ColorType } from '@types';

const IconSet = createIconSetFromIcoMoon(
  require('../../../assets/icomoon/selection.json'),
  'IcoMoon',
  'icomoon.ttf',
);

export interface IIconProps extends TextProps {
  size?: number;
  name: string;
  color?: ColorType;
}

const StyledIconSet = styled(IconSet)((props: IIconProps) => ({
  color: props.color ?? '$heading800',
}));

export function Icon(props: IIconProps) {
  return <StyledIconSet {...props} />;
}
